/* ── live sync: Shopify is the source of truth for price, sale price and stock.
      Patches window.CATALOG from /products.json before the shop renders, then
      loads the page scripts in order. If the fetch fails we still boot, using
      the prices baked into eco-catalog.js. ── */
(function () {
  // eco-pdp needs window.ECO_CART, so it must come after eco-cart
  var SCRIPTS = ['eco-shop.js', 'eco-cart.js', 'eco-pdp.js', 'eco-page.js',
                 'eco-chat.js', 'eco-popup-guard.js'];
  var base = (document.currentScript && document.currentScript.src || '').replace(/eco-boot\.js.*$/, '');

  /* On phones the full-size scrub videos are ~24MB of cellular data. Swap in the
     720px encodes instead — same duration, so the scroll scrubbing stays in sync,
     and the section still plays exactly as designed. */
  function useMobileVideos() {
    var w = window.innerWidth || document.documentElement.clientWidth || 0;
    if (w <= 0 || w > 760) return;      // w of 0 means the viewport isn't measurable yet
    ['heroVideo', 'soilVideo'].forEach(function (id) {
      var v = document.getElementById(id);
      var s = v && v.querySelector('source');
      if (!s) return;
      /* the mobile URL comes from Liquid so it carries its own ?v= cache key —
         building it by string surgery dropped the key and served a stale file */
      var mobile = s.getAttribute('data-mobile-src');
      if (!mobile || s.getAttribute('src') === mobile) return;
      s.setAttribute('src', mobile);
      try { v.load(); } catch (e) {}
    });
  }

  /* Sale display is switched off store-wide: show one plain price, no struck-through
     "was" and no Save% badge. This only changes what the site shows — the compare-at
     prices still live in Shopify, and customers are still charged the current price.
     Set SHOW_SALE_PRICES back to true to bring the badges back. */
  var SHOW_SALE_PRICES = false;
  function applySaleDisplay() {
    if (SHOW_SALE_PRICES) return;
    (window.CATALOG || []).forEach(function (p) { p.was = null; });
  }

  function boot() {
    applySaleDisplay();
    useMobileVideos();
    SCRIPTS.forEach(function (name) {
      var s = document.createElement('script');
      s.src = base + name + (window.ECO_V ? '?v=' + window.ECO_V : '');
      s.async = false;            // preserve execution order
      document.body.appendChild(s);
    });
  }

  function patch(products) {
    var byHandle = {};
    products.forEach(function (p) { byHandle[p.handle] = p; });
    var synced = 0, changed = 0;

    (window.CATALOG || []).forEach(function (item) {
      var sp = byHandle[item.handle];
      if (!sp) { item.avail = false; return; }
      var v = null;
      for (var i = 0; i < sp.variants.length; i++) {
        if (String(sp.variants[i].id) === String(item.vid)) { v = sp.variants[i]; break; }
      }
      if (!v) v = sp.variants[0];

      var price = parseFloat(v.price);
      var was = v.compare_at_price ? parseFloat(v.compare_at_price) : null;
      if (price !== item.price || (was || 0) !== (item.was || 0)) changed++;

      item.price = price;
      item.was = (was && was > price) ? was : null;   // only a real discount counts
      item.avail = v.available !== false;
      item.vid = String(v.id);
      item.buy = '/cart/' + v.id + ':1';
      synced++;
    });

    window.ECO_SYNC = { synced: synced, changed: changed, total: (window.CATALOG || []).length };
  }

  var done = false;
  var go = function () { if (!done) { done = true; boot(); } };
  setTimeout(go, 5000);   // never let a slow request block the page

  var jobs = [
    fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.products) patch(d.products); })
  ];

  /* collection pages: gather every handle in the collection, past Liquid's 50 cap */
  if (window.ECO_COLLECTION) {
    jobs.push(
      fetch('/collections/' + window.ECO_COLLECTION + '/products.json?limit=250',
            { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.products) {
            window.ECO_SUBSET = d.products.map(function (p) { return p.handle; });
          }
        })
    );
  }

  try {
    Promise.all(jobs.map(function (j) { return j.catch(function () {}); })).then(go, go);
  } catch (e) { go(); }
})();
